export const tableHeadersData = [
  {
    header: "fechaalta",
    title: "Fecha Alta",
    type: "datetime",
    footerDataType: "count",
  },
  { header: "idespecialidad_desc", title: "Especialidad", type: "string" },
  { header: "idpaciente_desc", title: "Paciente", type: "string" },
  {
    header: "importe",
    title: "Importe",
    type: "currency",
    textAlign: "right",
    footerDataType: "sum",
  },
  {
    header: "comprobante",
    title: "Comprobante",
    type: "icon",
    textAlign: "center",
    icon: "file pdf outline",
  },
];